import { Tooltip } from "react-bootstrap";
import { FORM_BUILDER_LISTING_URL, FormFrequency, IncidentPriority, LS_COMPANY_INFO_KEY, Months, ReportPageType, ReportSettingsFrequency, TaskPriority, USER_ROLE } from '../constants/common';
import moment from "moment";
import { toast } from "react-toastify";
import { prepareHtmlForDocxExport } from './wordDocxExportPrep';

export default class Utils {
  static encodeBase64(string) {
    return btoa(string);
  }
  static decodeBase64(string) {
    return atob(string);
  }

  /**
   * Decode Base64 where the underlying bytes are UTF-8 (e.g. stored report HTML with ₹).
   * Prefer this over decodeURIComponent(escape(atob(...))) for reliability across runtimes.
   * @param {string} base64
   * @returns {string}
   */
  static decodeBase64Utf8(base64) {
    const binary = atob(base64);
    if (typeof TextDecoder !== 'undefined') {
      const len = binary.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return new TextDecoder('utf-8', { fatal: false }).decode(bytes);
    }
    return decodeURIComponent(escape(binary));
  }

  /**
   * When UTF-8 rupee was misread as Windows-1252, it appears as U+00E2 U+201A U+00B9.
   * @param {string} text
   * @returns {string}
   */
  static repairRupeeMojibake(text) {
    if (text == null || text === '') return text;
    return String(text).replace(/\u00E2\u201A\u00B9/g, '\u20B9');
  }
  static generateUrlParamCompanyRegulation(company, regulation) {
    const obj = { cid: company, rid: regulation, sid: null };
    const myJSON = JSON.stringify(obj);
    return myJSON;
  }

  static generateUrlParamCompanyRegulationWithSupplier(
    company,
    regulation,
    supplierId
  ) {
    const obj = { cid: company, rid: regulation, sid: supplierId };
    const myJSON = JSON.stringify(obj);
    return myJSON;
  }

  static renderTooltip(text) {
    return <Tooltip>{text}</Tooltip>;
  }

  static getOrdinalNumber(num) {
    const j = num % 10;
    const k = num % 100;
    if (j === 1 && k !== 11) {
      return num + "st";
    }
    if (j === 2 && k !== 12) {
      return num + "nd";
    }
    if (j === 3 && k !== 13) {
      return num + "rd";
    }
    return num + "th";
  }
  static generateUrlParamFormCreate(
    action,
    authToken,
    formType,
    regulationId,
    externalId = "",
    key = "",
    sId = "",
    hasPermission = null,
    qParams = null,
  ) {
    let obj = null;
    // var myJSON = null;
    switch (action) {
      case "NEW":
        obj = { a: action, at: authToken, ft: formType, id: regulationId };
        break;
      case "EDIT":
        obj = {
          a: action,
          at: authToken,
          ft: formType,
          id: regulationId,
          eId: externalId,
          hasPermission: hasPermission
        };
        if (qParams) {
          obj = {
            ...obj,
            params: qParams
          };
        }
        break;
      case "SUBMIT":
        if (sId) {
          obj = {
            a: action,
            at: authToken,
            ft: formType,
            id: regulationId,
            eId: externalId,
            k: key,
            sId: sId,
          };
          if (qParams) {
            obj = {
              ...obj,
              params: qParams
            };
          }
        } else {
          obj = {
            a: action,
            at: authToken,
            ft: formType,
            id: regulationId,
            eId: externalId,
            k: key
          };
        }
        break;
      case "SHARE":
        if (sId) {
          obj = {
            a: action,
            at: authToken,
            ft: formType,
            id: regulationId,
            eId: externalId,
            k: key,
            sId: sId
          };
        } else {
          obj = {
            a: action,
            at: authToken,
            ft: formType,
            id: regulationId,
            eId: externalId,
            k: key
          };
        }
        break;
        case "REVIEW":
          if (sId) {
            obj = {
              a: action,
              at: authToken,
              ft: formType,
              id: regulationId,
              eId: externalId,
              k: key,
              sId: sId,
            };
            if (qParams) {
              obj = {
                ...obj,
                params: qParams
              };
            }
          }
          break;
      default:
        break;
    }
    const myJSON = JSON.stringify(obj);
    return myJSON;
  }

  static nameInitials(name) {
    if (!name) return '';
    
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

    let initials = [...name.matchAll(rgx)];

    initials = (
      (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
    ).toUpperCase();
    return initials;
  }
  static recentDate() {
    let year = new Date().getFullYear();
    return `${year}-01-01`;
  }
  static sentenceCase(str) {
    return str
      .split(' ')
      .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  static getMonthFromFrequency(frequency) {
    switch (frequency) {
      case 'FINANCIAL_YEAR':
        return '04';
      case 'ANNUAL':
      case 'QUARTERLY':
      case 'HALF_YEARLY':
      default:
        let month = new Date().getMonth();
        month += 1;
        if (month < 10) {
          return `0${month}`;
        }
        return `${month}`;
    }
  }

  static getUserRoleText = (role) => {
    switch (role) {
      case USER_ROLE.SUPER_ADMIN: return "Super Admin";
      case USER_ROLE.SUPPORT_USER: return "Support User";
      case USER_ROLE.SUPPLIER_ADMIN: return "Supplier Admin";
      case USER_ROLE.SUPPLIER_RISK_ASSESSOR: return "Supplier Risk Assessor";
      case USER_ROLE.SUPPLIER_TEAM_MEMBER: return "Supplier Team Member";
      case USER_ROLE.CONSULTANT: return "Consultant";
      default: return '';
    }
  }

  static getTaskPriorityText = (priority) => {
    switch (priority) {
      case TaskPriority.MEDIUM:
        return "Medium";
      case TaskPriority.HIGH:
        return "High";
      case TaskPriority.CRITICAL:
        return "Critical";
      default:
        return "Low";
    }
  }

  static getIncidentPriorityText = (priority) => {
    switch (priority) {
      case IncidentPriority.MEDIUM:
        return "Medium";
      case IncidentPriority.HIGH:
        return "High";
      default:
        return "Low";
    }
  }

  /**
   * Returns if the string value is empty or not.
   */
  static isEmpty = (value) => {
    return value === undefined || value === null || value === '' || value.trim() === '';
  }

  /**
   * Returns if the string value is not empty or not.
   */
  static isNotEmpty = (value) => {
    return !Utils.isEmpty(value);
  }

  static toCamelCase(str) {
    if (str !== null && str !== undefined) {
      return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
    } else {
      return null;
    }

  }

  static endOfDay = (date) => {
    const end = new Date(date);
    end.setHours(23, 59, 59, 999);
    return end;
  }

  static getFormURLForEdit = (form, authToken) => {
    const str = Utils.generateUrlParamFormCreate(
      "EDIT",
      authToken,
      "ASSESSMENT",
      form?.regulation?.id,
      form?.id,
      "",
      "",
      form?.locationSpecific
    );
    return FORM_BUILDER_LISTING_URL + `/?q=${Utils.encodeBase64(str)}`;
  };

  static getTextBasedProfilePic = (text) => {
    if (Utils.isEmpty(text)) return '';

    const words = text.match(/\b(\w+)\b/g);
    if (words.length === 1) {
      return `${words[0].charAt(0).toUpperCase()}${words[0].charAt(1).toUpperCase()}`;
    } else {
      return `${words[0].charAt(0).toUpperCase()}${words[1].charAt(0).toUpperCase()}`;
    }
  }

  static reportingPeriodToReadableText = (period, frequency, t) => {
    if (!period) return;

    const year = period.split('-')[0];
    const month = period.split('-')[1];
    switch (frequency) {
      case 'ANNUAL':
        return year ?? period;
      case 'FINANCIAL_YEAR':
        return `${year}, FY April-March`;
      case 'QUARTERLY': {
        switch (month) {
          case '01': return `${year}, Q1`;
          case '04': return `${year}, Q2`;
          case '07': return `${year}, Q3`;
          case '10': return `${year}, Q4`;
          default: return `${year}, Q1`;
        }
      }
      case 'HALF_YEARLY':
        return `${year}, ${month ? 'JAN-JUN' : 'JUL-DEC'}`;
      default: {
        return `${year}, ${Months({ t }).find(m => m.value === month)?.label}`;
      }
    }
  };

  static reportingPeriodToReadableTextYearOnly = (period, frequency, t) => {
    if (!period) return;

    const year = period.split('-')[0];
    const month = period.split('-')[1];
    switch (frequency) {
      case 'ANNUAL':
        return year ?? period;
      case 'FINANCIAL_YEAR':
        return `${year}, FY April-March`;
      case 'QUARTERLY': {
        switch (month) {
          case '01': return `${year}, Q1`;
          case '04': return `${year}, Q2`;
          case '07': return `${year}, Q3`;
          case '10': return `${year}, Q4`;
          default: return `${year}, Q1`;
        }
      }
      case 'HALF_YEARLY':
        return `${year}`;
      default: {
        return `${year}`;
      }
    }
  };

  static getDecodedHexForGraphColor = (color) => {
    switch (color) {
      case 'GREEN':
        return {
          borderColor: '#048004',
          backgroundColor: '#048004'
        };
      case 'YELLOW':
        return {
          borderColor: '#D19601',
          backgroundColor: '#D19601'
        };
      case 'CYAN':
        return {
          borderColor: '#22cfcf',
          backgroundColor: '#22cfcf'
        };
      case 'VIOLET':
        return {
          borderColor: '#9966ff',
          backgroundColor: '#9966ff'
        };
      case 'RED':
        return {
          borderColor: '#e02524',
          backgroundColor: '#e02524'
        };
      case 'GREY':
        return {
          borderColor: '#808080',
          backgroundColor: '#808080'
        };
      case 'ORANGE':
        return {
          borderColor: '#e8761c',
          backgroundColor: '#e8761c'
        };
      case 'ROYAL_BLUE':
        return {
          borderColor: '#4169E1',
          backgroundColor: '#4169E1'
        };
      case 'SANDY_BROWN':
        return {
          borderColor: '#F4A460',
          backgroundColor: '#F4A460'
        };
      case 'LAVENDER_GREY':
        return {
          borderColor: '#9a83b9',
          backgroundColor: '#9a83b9'
        };
      case 'EMERALD_GREEN':
        return {
          borderColor: '#008060',
          backgroundColor: '#008060'
        };
      case 'SILVER_GREY':
        return {
          borderColor: '#C0C0C0',
          backgroundColor: '#C0C0C0'
        };
      case 'BLUE':
      default:
        return {
          borderColor: '#1d4ed8 ',
          backgroundColor: '#1d4ed8'
        };
    }
  }

  static getLastDayFor = (date) => {
    let d = new Date(date);
    const lastday = new Date(d.getFullYear(), d.getMonth() + 1, 0);
    return lastday.getDate();
  }

  static formattedNumber = (val) => {
    if (val === undefined || val === null) {
      return '';
    }

    if (Number.isInteger(val)) {
      return val.toLocaleString(navigator.languages[0]);
    } else {
      return val.toLocaleString(navigator.languages[0], {
        minimumFractionDigits: 4
      });
    }
  };

  /**
   * Formats a number with thousand separators (commas) using en-US locale
   * Displays a fixed number of fraction digits (default 4), except for zero which displays as "0"
   * Handles null/undefined, string inputs, and ensures thousand separators are always shown
   * @param {number|string|null|undefined} num - The number to format
   * @param {number} [fractionDigits=4] - Decimal places to show (clamped 0–20)
   * @returns {string} - Formatted number with thousand separators, or '0' if zero, or '0' if invalid
   * @example
   * Utils.formatNumberWithThousandSeparators(0) // Returns "0"
   * Utils.formatNumberWithThousandSeparators(2624) // Returns "2,624.0000"
   * Utils.formatNumberWithThousandSeparators(555555541) // Returns "555,555,541.0000"
   * Utils.formatNumberWithThousandSeparators(2624.5) // Returns "2,624.5000"
   * Utils.formatNumberWithThousandSeparators(2624.123456) // Returns "2,624.1235"
   */
  static formatNumberWithThousandSeparators = (num, fractionDigits = 4) => {
    if (num === null || num === undefined) return '0';
    // Convert to number, handling both string and number inputs
    const numValue = typeof num === 'string' ? parseFloat(num.replace(/[^\d.-]/g, '')) : Number(num);
    if (isNaN(numValue)) return '0';
    // If the value is 0, return just "0" instead of "0.0000"
    if (numValue === 0) return '0';
    const fd = Math.min(20, Math.max(0, Math.floor(Number(fractionDigits)) || 0));
    // Format with commas using toLocaleString - ensures thousand separators are always shown
    return numValue.toLocaleString('en-US', {
      minimumFractionDigits: fd,
      maximumFractionDigits: fd,
      useGrouping: true // Explicitly enable grouping (thousand separators)
    });
  };

  /**
   * Formats a number with thousand separators for Y-axis labels
   * Only shows decimal places if they exist (no trailing zeros)
   * @param {number|string|null|undefined} num - The number to format
   * @returns {string} - Formatted number with thousand separators, decimals only if present
   * @example
   * Utils.formatYAxisValue(0) // Returns "0"
   * Utils.formatYAxisValue(1000) // Returns "1,000"
   * Utils.formatYAxisValue(1234.5) // Returns "1,234.5"
   * Utils.formatYAxisValue(1234.5678) // Returns "1,234.5678"
   */
  static formatYAxisValue = (num) => {
    if (num === null || num === undefined) return '0';
    // Convert to number, handling both string and number inputs
    const numValue = typeof num === 'string' ? parseFloat(num.replace(/[^\d.-]/g, '')) : Number(num);
    if (isNaN(numValue)) return '0';
    // If the value is 0, return just "0"
    if (numValue === 0) return '0';
    // Check if it's an integer
    if (Number.isInteger(numValue)) {
      // Format integer with thousand separators, no decimals
      return numValue.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: true
      });
    }
    // For decimal numbers, format with thousand separators and preserve decimals
    // First format with enough decimal places
    const formatted = numValue.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 20, // Allow up to 20 decimal places
      useGrouping: true
    });
    // Remove trailing zeros after decimal point
    // First remove all trailing zeros, then remove decimal point if no decimals remain
    return formatted.replace(/\.?0+$/, '');
  };

  /**
   * Formats a value string (number + unit) with thousand separators
   * @param {number|string|null|undefined} value - The numeric value to format
   * @param {string} unit - The unit of measure to append (optional)
   * @returns {string} - Formatted number with unit, or just formatted number if no unit
   * @example
   * Utils.formatValueStringWithThousandSeparators(2624, 'kg') // Returns "2,624 kg"
   * Utils.formatValueStringWithThousandSeparators(555555541, 'tons') // Returns "555,555,541 tons"
   */
  static formatValueStringWithThousandSeparators = (value, unit = '') => {
    // Ensure value is a number, not a string
    const numValue = value === null || value === undefined ? 0 : Number(value);
    const formattedNumber = Utils.formatNumberWithThousandSeparators(numValue);
    const trimmedUnit = unit ? unit.trim() : '';
    return trimmedUnit ? `${formattedNumber} ${trimmedUnit}` : formattedNumber;
  };

  static getYearFrom = (d) => {
    return d ? new Date(d).getFullYear() : new Date().getFullYear();
  }

  static parseAIConfigSectionIdFromReportPageType = (type) => {
    switch (type) {
      case ReportPageType.ESG_GOALS: return 'ESGGOALS';
      case ReportPageType.ENV_OVERVIEW: return 'ENVIRONMENTOVERVIEW';
      case ReportPageType.ENERGY: return 'ENVIRONMENTENERGY';
      case ReportPageType.CARBON_EMISSION: return 'ENVIRONMENTCARBONEMISSIONS';
      case ReportPageType.WASTE: return 'ENVIRONMENTWASTE';
      case ReportPageType.WATER: return 'ENVIRONMENTWATERCONSUMPTION';
      case ReportPageType.SOCIAL_OVERVIEW: return 'SOCIALOVERVIEW';
      case ReportPageType.CUSTOMERS: return 'SOCIALCUSTOMERS';
      case ReportPageType.COMMUNITY: return 'SOCIALCOMMUNITY';
      case ReportPageType.EMPLOYEES: return 'SOCIALEMPLOYEES';
      case ReportPageType.SUPPLIERS: return 'SOCIALSUPPLIERS';
      case ReportPageType.GOV_OVERVIEW: return 'GOVERNANCEOVERVIEW';
      case ReportPageType.ESG_GOV: return 'GOVERNANCEESGGOVERNANCE';
      case ReportPageType.BOARD_GOV: return 'GOVERNANCEBOARDGOVERNANCE';
      case ReportPageType.HUMAN_RIGHTS: return 'GOVERNANCEHUMANRIGHTS';
      case ReportPageType.ETHICS_COMP: return 'GOVERNANCEETHICSCOMPLIANCE';
      case ReportPageType.TAX_POLICY: return 'GOVERNANCETAXPOLICY';
      case ReportPageType.ABOUT_COMPANY: return 'ABOUTTHECOMPANY';
      case ReportPageType.ABOUT_REPORT: return 'ABOUTTHEREPORT';
      case ReportPageType.OTHERS: return 'DYNAMICSECTION';
      default: return '';
    }
  }

  /**
   * https://stackoverflow.com/questions/29255843/is-there-a-way-to-reverse-the-formatting-by-intl-numberformat-in-javascript
  * Parse a localized number to a float.
  * @param {string} stringNumber - the localized number
  * @param {string} locale - [optional] the locale that the number is represented in. Omit this parameter to use the current locale.
  */
  static parseLocaleNumber(stringNumber, locale) {
    if (!locale) {
      locale = navigator.languages[0];
    }
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');

    return parseFloat(stringNumber
      .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
      .replace(new RegExp('\\' + decimalSeparator), '.')
    );
  }

  static getChartColorBasedOnIndex(index) {
    if ((index + 5) % 5 === 0) {
      return {
        borderColor: '#397FF4',
        backgroundColor: '#D7E5FD'
      };
    } else if ((index + 5) % 5 === 1) {
      return {
        borderColor: '#07B401',
        backgroundColor: '#C1EDC0'
      };
    } else if ((index + 5) % 5 === 2) {
      return {
        borderColor: '#ffce56',
        backgroundColor: '#ffce5680'
      };
    } else if ((index + 5) % 5 === 3) {
      return {
        borderColor: '#4bc0c0',
        backgroundColor: '#4bc0c033'
      };
    } else if ((index + 5) % 5 === 4) {
      return {
        borderColor: '#9966ff',
        backgroundColor: '#9966ff33'
      };
    }
  }

  static formatDate = (date) => {
    const today = new Date();
    const options = { year: 'numeric', month: 'short', day: 'numeric' };

    // Check if the date is the current date
    if (date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()) {
      return 'Today';
    } else {
      return date.toLocaleDateString('en-US', options);
    }
  };

  // Function to convert an image to a base64 string
  static convertImgToBase64(url, callback) {
    try {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onerror = (e) => {
        callback(null);
      };
      img.onload = function () {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        callback(dataURL);
      };
      img.src = url;
    } catch (err) {
      callback(null);
    }
  }

  /** Embed images for DOCX; pass { ghgInnerImages: true } for 55% inner GHG image width. */
  static replaceImgWithBase64(htmlString, callback, options = {}) {
    prepareHtmlForDocxExport(htmlString, callback, options);
  }

  static getMonthsForYear(year) {
    const monthNames = [
      { name: "Jan", digit: '01' },
      { name: "Feb", digit: '02' },
      { name: "Mar", digit: '03' },
      { name: "Apr", digit: '04' },
      { name: "May", digit: '05' },
      { name: "Jun", digit: '06' },
      { name: "Jul", digit: '07' },
      { name: "Aug", digit: '08' },
      { name: "Sep", digit: '09' },
      { name: "Oct", digit: '10' },
      { name: "Nov", digit: '11' },
      { name: "Dec", digit: '12' },
    ];
    return monthNames.map((month, index) => {
      return {
        index: index + 1,
        value: `${month.name}`,
        date: `${year}-${month.digit}-01`
      }
    });
  }

  static contentExtractionFileExceedsMaxSize(file) {
    // Max size of 5MB allowed
    return (file.size / (1024 * 1024)) > 5;
  }

  static toTitleCase(str) {
    return str.replace(
      /\w\S*/g,
      text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
  }

  static getRecurrenceText(frequency) {
    switch (frequency) {
      case FormFrequency.MONTHLY.text:
        return `Repeat every 1 month`;
      case FormFrequency.QUARTERLY.text:
        return `Repeat every 3 months`;
      case FormFrequency.HALF_YEARLY.text:
        return `Repeat every 6 months`;
      case FormFrequency.ANNUALLY.text:
        return `Repeat every 1 year`;
    }
  };

  static convertMarkdownToHTML(inputString) {
    // Created using GPT 

    // Replace \n with <br> for line breaks
    let htmlString = inputString.replace(/\n/g, '<br>');

    // Convert markdown-style bold (**text**) to <strong>
    htmlString = htmlString.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    // Convert numbered lists (1. text) to <ol><li>text</li></ol>
    // Safe regex: uses greedy quantifier to prevent catastrophic backtracking (ReDoS protection)
    // Matches digits, period, space, then any non-< characters until <br> or end of string
    // Greedy quantifier avoids backtracking by matching maximally first, then checking lookahead
    htmlString = htmlString.replace(/(\d+)\.\s([^<]*)(?=<br>|$)/g, '<li>$2</li>');


    if (htmlString.includes('<li>')) {
      htmlString = '<ol>' + htmlString + '</ol>';
    }

    // Convert unordered list (- text) to <ul><li>text</li></ul>
    // Safe regex: uses greedy quantifier to prevent catastrophic backtracking (ReDoS protection)
    htmlString = htmlString.replace(/-\s([^<]*)(?=<br>|$)/g, '<li>$1</li>');
    if (htmlString.includes('<li>')) {
      htmlString = htmlString.replace(/(<li>.*?<\/li>)/g, '<ul>$1</ul>');
    }

    // Remove nested <ul> or <ol> by flattening lists
    htmlString = htmlString.replace(/<\/ul><ul>/g, '');
    htmlString = htmlString.replace(/<\/ol><ol>/g, '');

    return htmlString;
  }

  static getDynamicProgressBarColors(data) {
    // Created using GPT

    const keys = Object.keys(data);
    const colors = {};

    keys.forEach((key, index) => {
      // Generate a unique HSL color based on the index
      const hue = (index * 137.5) % 360; // Use golden angle approximation for even distribution
      const saturation = '70%'; // Adjust saturation as needed
      const lightness = '60%'; // Adjust lightness as needed

      colors[key] = `hsl(${hue}, ${saturation}, ${lightness})`;
    });

    return colors;
  }

  static updateVersionSuffix(name) {
    if (name == null || typeof name !== 'string') {
      return name;
    }
    return name.replace(/\bV(\d+)\b/g, 'Version $1');
  }

  static formatDateAsDaysAgo(dateString) {
    const lastModifiedDate = moment(dateString);
    const currentDate = moment();

    const timeDifference = moment.duration(currentDate.diff(lastModifiedDate));
    const daysAgo = Math.floor(timeDifference.asDays());
    if (daysAgo === 0) {
      return "Today";
    } else if (daysAgo === 1) {
      return "Yesterday";
    } else {
      return `${daysAgo} Days ago`;
    }
  }

  static setupDynamicGraphLayoutConfigFor({ graphs, lData, activeLayoutConfig }) {
    let layoutData = [];
    if (lData) {
      // Format all layout data
      lData?.layout?.forEach(l => {
        layoutData.push({
          ...l,
          i: `graph-${l.i}`,
        });
      });
      // Setup layout for exsiting categrozied graphs
      graphs?.forEach(g => {
        const matchingLayout = layoutData?.find(l => `graph-${g.id}` === l.i);
        if (matchingLayout) {
          matchingLayout.minW = g.type === 'KPI' ? 4 : 5;
          matchingLayout.minH = g.type === 'KPI' ? 4 : 8;
        } else {
          // If no layout exists for a graph, then add it to the bottom,
          // calculate the maximum `y` + `h` to find the bottom of the layout
          const bottomY = layoutData?.reduce((max, item) => Math.max(max, item.y + item.h), 0);
          layoutData.push({
            w: 6,
            h: 9,
            x: 0, // Start at the beginning of a new row
            i: `graph-${g.id}`,
            y: bottomY,
            minW: g.type === 'KPI' ? 4 : 5,
            minH: g.type === 'KPI' ? 4 : 8,
          });
        }
      });
    } else {
      layoutData = graphs.map((graph, index) => ({
        i: `graph-${graph.id}`,
        x: (index % 2) * 6, // Arrange in two columns
        y: Math.floor(index / 2) * 9, // Stack rows
        w: 6, // Fixed width
        h: 9, // Fixed height
        // For all graphs except KPI we dont allow resizing below a certain dimension
        minW: graph.type === 'KPI' ? 3 : 4,
        minH: graph.type === 'KPI' ? 3 : 7,
      }));
    }
    // Populate layout from other categories as well
    const existingLayoutData = JSON.parse(JSON.stringify(activeLayoutConfig.layout ?? []));
    const uniqueLayoutData = new Map();
    layoutData.forEach(l => uniqueLayoutData.set(l.i, l));
    // Add only unique vlaues
    existingLayoutData.forEach(o => {
      if (!uniqueLayoutData.has(o.i)) {
        uniqueLayoutData.set(o.i, o);
      }
    });
    return Array.from(uniqueLayoutData.values());
  }

  // Helper function to get the last day of a month
  // month should be 1-indexed (1-12) representing January through December
  static getLastDayOfMonth = (year, month) => {
    // JavaScript Date months are 0-indexed (0-11), but we receive 1-indexed (1-12)
    // new Date(year, month, 0) gives the last day of (month-1) in 0-indexed terms
    // So for month=4 (April in 1-indexed), new Date(2025, 4, 0) gives last day of month 3 (April) = 30
    // This is correct because month 4 in Date constructor is May, and day 0 of May = last day of April
    return new Date(year, month, 0).getDate();
  };

  // Helper function to format period end as last day of month
  static formatPeriodEnd = (periodEnd) => {
    if (!periodEnd) return '';
    const [year, month] = periodEnd.split('-');
    const lastDay = Utils.getLastDayOfMonth(parseInt(year), parseInt(month));
    return `${year}-${month}-${lastDay.toString().padStart(2, '0')}`;
  };

  static decrementYearByString(dateString) {
    // Split the string into an array of [year, month, day]
    let parts = dateString.split('-');

    // Get the year, convert it to a number, decrement, and convert back to a string
    let year = (parseInt(parts[0]) - 1).toString();

    // Replace the old year with the new one
    parts[0] = year;

    // Join the parts back together with a hyphen
    return parts.join('-');
  }

  static convertNumberStringToArray(stringValue) {
    if (!stringValue) return [];

    return stringValue.split(',').map(Number);
  }

  static getMonthNumber(monthName) {
    const monthMap = {
      'JANUARY': '01', 'FEBRUARY': '02', 'MARCH': '03', 'APRIL': '04',
      'MAY': '05', 'JUNE': '06', 'JULY': '07', 'AUGUST': '08',
      'SEPTEMBER': '09', 'OCTOBER': '10', 'NOVEMBER': '11', 'DECEMBER': '12'
    };
    return monthMap[monthName?.toUpperCase()] || '01';
  }

  /**
 * Calculates the column number (1-indexed) from an Excel-like column string
 * followed by a row number (e.g., 'A1' -> 1, 'Z1' -> 26).
 *
 * @param {string} columnString The cell string (e.g., 'A1', 'B1', 'Z1').
 * @returns {number} The corresponding column number (1 for A, 2 for B, etc.).
 */
  static getColumnNumber = (columnString) => {
    if (!columnString || typeof columnString !== 'string') {
      return 0; // Return 0 or throw an error for invalid input
    }

    // Use a regular expression to extract the column letters (e.g., 'A', 'B', 'Z')
    // and ignore the row number (the digits).
    // The pattern /^([a-zA-Z]+)/ matches one or more letters at the start of the string.
    const match = columnString.match(/^([a-zA-Z]+)/);

    if (!match) {
      return 0; // Return 0 if no column letters are found
    }

    // The column letters are in the first capturing group of the regex match
    const columnLetters = match[1].toUpperCase();
    let columnNumber = 0;

    // Iterate through the column letters from left to right (e.g., 'AA' -> A, then A)
    // This logic is required for columns like AA, AB, etc. (27, 28, etc.)
    for (let i = 0; i < columnLetters.length; i++) {
      const char = columnLetters[i];
      // ASCII value of 'A' is 65. Subtracting it gives 0 for 'A', 1 for 'B', etc.
      // Adding 1 makes it 1 for 'A', 2 for 'B', etc.
      const charValue = char.charCodeAt(0) - 'A'.charCodeAt(0) + 1;

      // In Excel column numbering (base-26 with a twist):
      // 'A' = 1, 'B' = 2, ..., 'Z' = 26
      // 'AA' = 26*1 + 1 = 27
      // 'AB' = 26*1 + 2 = 28
      // 'BA' = 26*2 + 1 = 53
      // For 'A', columnNumber starts at 0, then 0 * 26 + 1 = 1.
      // For 'B', columnNumber starts at 0, then 0 * 26 + 2 = 2.
      // For 'Z', columnNumber starts at 0, then 0 * 26 + 26 = 26.
      // For 'AA':
      //   1. 'A': columnNumber = 0 * 26 + 1 = 1
      //   2. 'A': columnNumber = 1 * 26 + 1 = 27
      columnNumber = columnNumber * 26 + charValue;
    }

    return columnNumber;
  };
  /**
   * Rounds a finite number to the specified decimal places and returns it as a string.
   * Only values that are clearly numeric are rounded: actual numbers, or strings that contain
   * digits (and at most one leading minus and one decimal point) with no other characters.
   * Examples returned unchanged: "+919747991852" (leading +), "06-04-1194" (non-numeric chars), "12 3" (spaces).
   * @param {number|string} value - The value to round
   * @param {number} decimalPlaces - The number of decimal places (defaults to 2)
   * @returns {string} - The rounded value as a string, or the original value unchanged for non-numeric strings
   */
  static roundToDecimalPlacesIfNumber = (value, decimalPlaces = 2) => {
    // Handle null, undefined, or empty string
    if (value === null || value === undefined || value === '') {
      return '';
    }

    if (typeof value === 'number') {
      if (!isFinite(value)) {
        return String(value);
      }
      return Utils._roundNumericValue(value, decimalPlaces);
    }

    if (typeof value !== 'string') {
      return value;
    }

    const trimmed = value.trim();
    if (trimmed === '') {
      return '';
    }

    // Internal/leading/trailing spaces => treat as plain text (e.g. "12 3")
    if (/\s/.test(trimmed)) {
      return value;
    }

    // Strict numeric string: optional leading '-', digits, optional '.' and fractional digits.
    // Rejects '+…' (phones), '06-04-…' (dates), '1e3' (exponent), etc.
    if (!/^-?(?:\d+\.?\d*|\.\d+)$/.test(trimmed)) {
      return value;
    }

    const numValue = parseFloat(trimmed);
    if (isNaN(numValue)) {
      return value;
    }

    return Utils._roundNumericValue(numValue, decimalPlaces);
  };

  /**
   * @param {number} numValue
   * @param {number} decimalPlaces
   * @returns {string}
   */
  static _roundNumericValue = (numValue, decimalPlaces) => {
    const multiplier = Math.pow(10, decimalPlaces);
    const rounded = Math.round(numValue * multiplier) / multiplier;

    if (rounded % 1 === 0) {
      return rounded.toString();
    }

    return rounded.toFixed(decimalPlaces);
  };

  
  static roundedPercentage = (val) => {
    if (val === undefined || val === null) {
      return '';
    }

    return Number(val.toFixed(2));    
  };

  /**
   * Trims leading and trailing whitespace from specified property values in an array of objects,
   * or trims a single string value.
   * @param {Array<Object>|string} input - An array of objects with the specified property, or a single string value
   * @param {string} propertyName - The name of the property to trim (default: 'key')
   * @returns {Array<Object>|string} - The input with trimmed property values, or trimmed string value
   * @example
   * Utils.trimPropertyValues([{key: "  test  ", other: "value"}], 'key') // Returns [{key: "test", other: "value"}]
   * Utils.trimPropertyValues([{name: "  john  ", age: 25}], 'name') // Returns [{name: "john", age: 25}]
   * Utils.trimPropertyValues("  test  ") // Returns "test"
   * Utils.trimPropertyValues([{key: null}], 'key') // Returns [{key: null}]
   */
  static trimPropertyValues = (input, propertyName = 'key') => {
    if (input === null || input === undefined) {
      return input;
    }

    // Handle array of objects with specified property
    if (Array.isArray(input)) {
      return input.map(item => ({
        ...item,
        [propertyName]: item[propertyName] && typeof item[propertyName] === 'string' 
          ? item[propertyName].trim() 
          : item[propertyName]
      }));
    }

    // Handle single string value
    if (typeof input === 'string') {
      return input.trim();
    }

    // Return as-is for other types
    return input;
  };

  /**
   * Calculates default period start and end dates based on frequency and year
   * @param {string} frequency - ReportSettingsFrequency.CALENDAR_YEAR or ReportSettingsFrequency.FINANCIAL_YEAR
   * @param {number} yearToConsider - Year to consider for period calculation
   * @returns {Object} Object with defaultPeriodStart and defaultPeriodEnd
   */
  static calculateDefaultPeriods(frequency, yearToConsider) {
    let defaultPeriodStart = '';
    let defaultPeriodEnd = '';

    // Set default periods based on frequency
    if (frequency === ReportSettingsFrequency.CALENDAR_YEAR) {
      // Calendar year: Jan to Dec of current year
      defaultPeriodStart = `${yearToConsider}-01-01`;
      defaultPeriodEnd = `${yearToConsider}-12-31`;
    } else if (frequency === ReportSettingsFrequency.FINANCIAL_YEAR) {
      // Financial year: Use company's financial year settings
      const companyInfoJson = localStorage.getItem(LS_COMPANY_INFO_KEY);
      const companyInfo = companyInfoJson ? JSON.parse(companyInfoJson) : {};
      const financialYearStart = companyInfo?.financialYearStart || 'APRIL';
      const financialYearEnd = companyInfo?.financialYearEnd || 'MARCH';
      
      const startMonth = Utils.getMonthNumber(financialYearStart);
      const endMonth = Utils.getMonthNumber(financialYearEnd);
      
      // Financial year spans across two calendar years only when the start month
      // comes after the end month (e.g. April 2023 to March 2024). If start <= end
      // (e.g. January to December), the FY start and end fall in the same year.
      const startYear = parseInt(startMonth) > parseInt(endMonth) ? yearToConsider - 1 : yearToConsider;
      defaultPeriodStart = `${startYear}-${startMonth.padStart(2, '0')}-01`;
      
      // Calculate the end year based on the financial year end month
      const endYear = yearToConsider;
      // Use getLastDayOfMonth to get the correct last day for the month (handles 28, 30, 31 days correctly)
      const lastDay = Utils.getLastDayOfMonth(parseInt(endYear), parseInt(endMonth));
      defaultPeriodEnd = `${endYear}-${endMonth.padStart(2, '0')}-${lastDay.toString().padStart(2, '0')}`;
      
      // Validate the constructed dates to ensure they are valid
      const startDate = new Date(defaultPeriodStart);
      const endDate = new Date(defaultPeriodEnd);
      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        console.error('Invalid date constructed:', { defaultPeriodStart, defaultPeriodEnd, frequency, yearToConsider, endMonth, lastDay });
        // Fallback to calendar year if dates are invalid
        defaultPeriodStart = `${yearToConsider}-01-01`;
        defaultPeriodEnd = `${yearToConsider}-12-31`;
      } else {
        // Double-check that the date string matches the parsed date (catches cases like 2025-04-31)
        const [endYearStr, endMonthStr, endDayStr] = defaultPeriodEnd.split('-');
        if (endDate.getFullYear() !== parseInt(endYearStr) || 
          (endDate.getMonth() + 1) !== parseInt(endMonthStr) || 
          endDate.getDate() !== parseInt(endDayStr)) {
          console.error('Invalid date constructed (mismatch):', { 
            defaultPeriodEnd, 
            parsedDate: `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}`,
            frequency, 
            yearToConsider, 
            endMonth, 
            lastDay 
          });
          // Recalculate with correct last day
          const correctLastDay = Utils.getLastDayOfMonth(parseInt(endYearStr), parseInt(endMonthStr));
          defaultPeriodEnd = `${endYearStr}-${endMonthStr}-${correctLastDay.toString().padStart(2, '0')}`;
        }
      }
    }
    return { defaultPeriodStart, defaultPeriodEnd };
  }

  static extractCodesForEquationDrilldown = (equation = '') => {
    if (!equation || typeof equation !== 'string') {
      return { metricCodes: [], datapointCodes: [] };
    }

    const tokenRegex = /\b([MDEN])([A-Za-z0-9_]+)\b/g;
    const metricCodeSet = new Set();
    const datapointCodeSet = new Set();
    let match = tokenRegex.exec(equation);
    while (match) {
      const prefix = match[1];
      const code = match[2];
      if (prefix === 'M' || prefix === 'N') {
        metricCodeSet.add(code);
      } else if (prefix === 'D' || prefix === 'E') {
        datapointCodeSet.add(code);
      }
      match = tokenRegex.exec(equation);
    }

    return {
      metricCodes: Array.from(metricCodeSet),
      datapointCodes: Array.from(datapointCodeSet)
    };
  }; 

  /**
   * Shows a toast summarizing an excel import API response of shape
   * { importedRowsCount, skippedRowsCount, errors }. The backend's own
   * "message" field is not a reliable success/failure indicator (it reads
   * "Import completed successfully." even when every row was skipped), so
   * the summary is derived from the counts/errors instead.
   */
  static showImportResultToast = (t, resp) => {
    const imported = Number(resp?.importedRowsCount ?? 0);
    const skipped = Number(resp?.skippedRowsCount ?? 0);
    const errors = Array.isArray(resp?.errors) ? resp.errors : [];

    if (skipped > 0 || errors.length > 0) {
      const summary = t("Import.result.partial.label", { imported, skipped });
      const detail = errors.length > 0 ? ` ${errors.join(" ")}` : "";
      toast.warning(`${summary}${detail}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: false,
      });
    } else {
      toast.success(t("Import.result.success.label", { imported }), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
}
